// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
    display: flex;
    align-items: center;
    background-color: var(--bs-slate-gray);
    padding: 10px;
  }
  
  .toolbar-icon {
    margin-right: 15px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    background-size: cover;
    color: white;
  }
  
  .toolbar-icon:last-child {
    margin-right: 0;
  }
  
  .toolbar-icon:disabled {
    /* Disabled button styling */
    color: var(--dark-gray);
    cursor: not-allowed;
  }
  
  .toolbar-icon.highlight > svg {
    /* Change color of FontAwesome icon */
    color: var(--bs-purple-pizzazz); /* Bootstrap primary color for highlight */
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/Toolbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,+BAA+B,EAAE,0CAA0C;EAC7E","sourcesContent":[".toolbar {\n    display: flex;\n    align-items: center;\n    background-color: var(--bs-slate-gray);\n    padding: 10px;\n  }\n  \n  .toolbar-icon {\n    margin-right: 15px;\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    background-size: cover;\n    color: white;\n  }\n  \n  .toolbar-icon:last-child {\n    margin-right: 0;\n  }\n  \n  .toolbar-icon:disabled {\n    /* Disabled button styling */\n    color: var(--dark-gray);\n    cursor: not-allowed;\n  }\n  \n  .toolbar-icon.highlight > svg {\n    /* Change color of FontAwesome icon */\n    color: var(--bs-purple-pizzazz); /* Bootstrap primary color for highlight */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
